module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedBold.a5634cc.ttf";